export const setLocalStorage = (id, data) => {
  const strData = JSON.stringify(data);
  localStorage.setItem(id, strData);
}